var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-balloon v-card v-card--raised v-card--hover",class:'avatar-' + _vm.avatarPosition + (_vm.focused ? ' focused' : '')},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }